const CHANGE_PARTNER = 'Mintifi/App/CHANGE_PARTNER';
const CHANGE_PARTNER_ADD_ACTION = 'Mintifi/App/CHANGE_PARTNER_ADD_ACTION';
const CHANGE_PARTNER_FLAG = 'Mintifi/App/CHANGE_PARTNER_FLAG';
const CHANGE_DIRECTOR = 'Mintifi/App/CHANGE_DIRECTOR';
const CHANGE_COMPANY = 'Mintifi/App/CHANGE_COMPANY'
const VERIFED_OTP = 'Mintifi/App/VERIFED_OTP'
const KNOW_YOUR_CREDIT = 'Mintifi/App/KNOW_YOUR_CREDIT'
const GET_PAN = 'Mintifi/App/GET_PAN'
const SET_PAN = 'Mintifi/App/SET_PAN'
const CREATE_BRO = 'Mintifi/App/CREATE_BRO'
const SAVE_BRO = 'Mintifi/App/SAVE_BRO'
const SEND_OTP = 'Mintifi/App/SEND_OTP'
const SEND_OTP_DATA = 'Mintifi/App/SEND_OTP_DATA'
const AUTH_USER = 'Mintifi/App/AUTH_USER'
const AUTH_TOKEN = 'Mintifi/App/AUTH_TOKEN'
const CREDIT_AVAIL_RESPONSE = 'Mintifi/App/CREDIT_AVAIL_RESPONSE'
const SET_OFFER = 'Mintifi/App/SET_OFFER'
const SAVE_OFFER = 'Mintifi/App/SAVE_OFFER'
const GET_DOCUMENT_LIST = 'Mintifi/App/GET_DOCUMENT_LIST'
const SAVE_DOCUMENT_LIST = 'Mintifi/App/SAVE_DOCUMENT_LIST'
const UPLOAD_DOCUMENT = 'Mintifi/App/UPLOAD_DOCUMENT'
const SET_WINDOW = 'Mintifi/App/SET_WINDOW'
const CLEAR_WINDOW = 'Mintifi/App/CLEAR_WINDOW'
const NEXT_ESIGN = 'Mintifi/App/NEXT_ESIGN'
const SET_TOAST = 'Mintifi/App/SET_TOAST'
const ERROR_PAN = 'Mintifi/App/ERROR_PAN'
const STOP_LOADER = 'Mintifi/App/STOP_LOADER'
const START_LOADER = 'Mintifi/App/START_LOADER'
const UPDATE_BRO = 'Mintifi/App/UPDATE_BRO'
const SAVE_UPDATE_BRO = 'Mintifi/App/SAVE_UPDATE_BRO'
const ESIGN_INIT = 'Mintifi/App/ESIGN_INIT'
const SAVE_ESIGN_INIT = 'Mintifi/App/SAVE_ESIGN_INIT'
const AUTH_TOKEN_BORROWER = 'Mintifi/App/AUTH_TOKEN_BORROWER'
const SET_STEP = 'Mintifi/App/SET_STEP'
const SET_REPEAT = 'Mintifi/App/SET_REPEAT'
const IFSC_API = 'Mintifi/App/IFSC_API'
const SAVE_IFSC_API = 'Mintifi/App/SAVE_IFSC_API'
const CHECK_ESIGN = 'Mintifi/App/CHECK_ESIGN'
const SAVE_ESIGN_LIST = 'Mintifi/App/SAVE_ESIGN_LIST'
const PENNY_DROP_CALL = 'Mintifi/App/PENNY_DROP_CALL'
const PENNY_DROP_DATA = 'Mintifi/App/PENNY_DROP_DATA'
const LOADER_IFSC_API = 'Mintifi/App/LOADER_IFSC_API'
const LOADER_PENNY_DROP_CALL = 'Mintifi/App/LOADER_PENNY_DROP_CALL'
const CREATE_BANK_ACC = 'Mintifi/App/CREATE_BANK_ACC'
const SAVE_BANK_ACC = 'Mintifi/App/SAVE_BANK_ACC'
const GET_BANK_LIST = 'Mintifi/App/GET_BANK_LIST'
const SAVE_BANK_LIST = 'Mintifi/App/SAVE_BANK_LIST'
const INIT_EMANDATE = 'Mintifi/App/INIT_EMANDATE'
const SAVE_INIT_EMANDATE = 'Mintifi/App/SAVE_INIT_EMANDATE'
const REMOVE_PARTNER = 'Mintifi/App/REMOVE_PARTNER'
const CHANGE_PARTNER_TEMP_FLAG = 'Mintifi/App/CHANGE_PARTNER_TEMP_FLAG'
const SET_API_KEY = 'Mintifi/App/SET_API_KEY'
const SET_CUST_CODE = 'Mintifi/App/SET_CUST_CODE'
const LOGOUT_USER = 'Mintifi/App/LOGOUT_USER'
const ERROR_ESIGN_INIT = 'Mintifi/App/ERROR_ESIGN_INIT'
const PHY_NACH = 'Mintifi/App/PHY_NACH'
const SAVE_PHY_NACH = 'Mintifi/App/SAVE_PHY_NACH'
const SET_API_STEP = 'Mintifi/App/SET_API_STEP'
const SAVE_EMANDATE_LIST = 'Mintifi/App/SAVE_EMANDATE_LIST';
const GET_ESIGN_DOCUMENT_LIST = 'Mintifi/App/GET_ESIGN_DOCUMENT_LIST'
const SET_REPEAT_MOBILE = 'Mintifi/App/SET_REPEAT_MOBILE'
const GET_EMAIL_ESIGN = 'Mintifi/App/GET_EMAIL_ESIGN'
const SAVE_EMAIL_ESIGN = 'Mintifi/App/SAVE_EMAIL_ESIGN'
const GET_PIN = 'Mintifi/App/GET_PIN'
const SET_PIN = 'Mintifi/App/SET_PIN'
const ADD_LOAD_DOCUMENT = 'Mintifi/App/ADD_LOAD_DOCUMENT'
const REMOVE_LOAD_DOCUMENT = 'Mintifi/App/REMOVE_LOAD_DOCUMENT'

export {
  CHANGE_PARTNER,
  CHANGE_PARTNER_ADD_ACTION,
  CHANGE_PARTNER_FLAG,
  CHANGE_DIRECTOR,
  CHANGE_COMPANY,
  VERIFED_OTP,
  KNOW_YOUR_CREDIT,
  GET_PAN,
  SET_PAN,
  CREATE_BRO,
  SEND_OTP,
  SEND_OTP_DATA,
  AUTH_USER,
  AUTH_TOKEN,
  CREDIT_AVAIL_RESPONSE,
  SET_OFFER,
  SAVE_OFFER,
  GET_DOCUMENT_LIST,
  SAVE_DOCUMENT_LIST,
  UPLOAD_DOCUMENT,
  SAVE_BRO,
  SET_WINDOW,
  CLEAR_WINDOW,
  NEXT_ESIGN,
  SET_TOAST,
  ERROR_PAN,
  STOP_LOADER,
  START_LOADER,
  UPDATE_BRO,
  SAVE_UPDATE_BRO,
  ESIGN_INIT,
  SAVE_ESIGN_INIT,
  AUTH_TOKEN_BORROWER,
  SET_STEP,
  SET_REPEAT,
  IFSC_API,
  SAVE_IFSC_API,
  CHECK_ESIGN,
  SAVE_ESIGN_LIST,
  PENNY_DROP_DATA,
  PENNY_DROP_CALL,
  LOADER_IFSC_API,
  LOADER_PENNY_DROP_CALL,
  CREATE_BANK_ACC,
  SAVE_BANK_ACC,
  GET_BANK_LIST,
  SAVE_BANK_LIST,
  INIT_EMANDATE,
  SAVE_INIT_EMANDATE,
  REMOVE_PARTNER,
  CHANGE_PARTNER_TEMP_FLAG,
  SET_API_KEY,
  SET_CUST_CODE,
  LOGOUT_USER,
  ERROR_ESIGN_INIT,
  GET_ESIGN_DOCUMENT_LIST,
  SET_API_STEP,
  SAVE_EMANDATE_LIST,
  SAVE_PHY_NACH,
  PHY_NACH,
  SET_REPEAT_MOBILE,
  GET_EMAIL_ESIGN,
  SAVE_EMAIL_ESIGN,
  ADD_LOAD_DOCUMENT,
  REMOVE_LOAD_DOCUMENT,
  GET_PIN,
  SET_PIN
};
